import {mat4} from 'gl-matrix';
import {create_buffer, GLSL} from './webgl';
import {use_program} from './shader-utils';

export function init_grid() {
    const size = 20;
    const count = 4 * (size + 1);
    const scale = 20;
    const c0 = 0.75;
    const c1 = 0.45;

    const verts = create_buffer(gl.ARRAY_BUFFER, make_grid_verts(size));
    const mvp = mat4.create();

    function draw(env) {
        const pgm = use_program('grid');
        if (!pgm) return;

        gl.disable(gl.DEPTH_TEST);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

        mat4.identity(mvp);
        mat4.scale(mvp, mvp, [scale, scale, scale]);
        mat4.multiply(mvp, env.camera.mvp, mvp);
        pgm.uniformMatrix4fv('uMatMVP', mvp);

        gl.bindBuffer(gl.ARRAY_BUFFER, verts);
        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);

        pgm.uniform4f('uColor', 1, 1, 1, c1);
        gl.drawArrays(gl.LINES, 0, count);

        gl.lineWidth(2);
        pgm.uniform4f('uColor', 0.9, 0, 0, c1);
        gl.drawArrays(gl.LINES, 2*size + 2, 2);

        pgm.uniform4f('uColor', 0, 0.3, 0.8, c1);
        gl.drawArrays(gl.LINES, 2*size + 0, 2);
        gl.lineWidth(1);

        gl.disable(gl.BLEND);
    }

    function update() {
    }

    return {update, draw};
}

function make_grid_verts(size) {
    const v = []; 
    for (let i = 0; i < size+1; ++i) {
        const u = 2*i/size - 1;
        v.push(u, -1, u, 1);
        v.push(-1, u, 1, u);
    }
    return v;
}

